<template>
  <div>
    <template v-if="this.$i18n.locale === 'ru'">
      <NestRu />
    </template>
    <template v-else>
      <NestEn />
    </template>
  </div>
</template>

<script>
/* eslint-disable func-names */
import NestRu from '../components/Nest/NestRu.vue'
import NestEn from '../components/Nest/NestEn.vue'

export default {
  components: {
    NestRu,
    NestEn,
  },
  watch: {
    '$i18n.locale': function (val) {
      if (val) {
        this.$router.replace(`/nest/${val}`)
      }
    },
  },
  mounted() {
    this.$root.$data.selectLang(this.$route.params.lang, this)
  },
}
</script>
